export const DASHBOARD_ACOES = {
  MEUS_PROCESSOS: 'meusProcessos',
  PROCESSOS_NOVOS: 'processosNovos',
  PROMESSAS_BOLETOS: 'promessasBoletos',
  ACORDOS_NAO_CUMPRIDOS: 'acordosNaoCumpridos',
  PRAZOS: 'prazos',
  PROMESSAS_RETORNO: 'promessasRetorno',
};
